import {View, Image, TouchableOpacity, StyleSheet} from 'react-native';
import React, {useEffect, useState, useRef} from 'react';
import {TRAINING_LIST_BASE_URL} from '../../utils/utils';
import {useSelector} from 'react-redux';
import {selectCourseId} from '../../redux/slices/CourseIdSlice';
import {
   selectAslPressClose,
   selectAslStatus,
   selectAslVolume,
} from '../../redux/slices/AslSlice';
import {Progressbar, MediaIcon} from './components';
import {isSafari} from 'react-device-detect';

const AudioPlayer = props => {
   const {url, dispatch} = props;
   const courseId = useSelector(selectCourseId);
   const asl = useSelector(selectAslStatus);
   const PressClose = useSelector(selectAslPressClose);
   const volume = useSelector(selectAslVolume);
   const playerPath = TRAINING_LIST_BASE_URL + courseId + url;
   const audioRef = useRef(null);
   const [isPlaying, setPlaying] = useState(false);
   const [percent, setPercent] = useState(0);
   const isMediaPlaying = props.isMediaPlaying;

   useEffect(() => {
      if (audioRef !== 'null' && audioRef.current) {
         audioRef?.current?.addEventListener('play', () => {
            //setPlaying(true);
            //dispatch(setPlayStatus('play'));
         });
         audioRef?.current?.addEventListener('pause', () => {
            setPlaying(false);
            //dispatch(setPlayStatus('pause'));
         });
         audioRef?.current?.addEventListener('ended', () => {
            setPlaying(false);
            //dispatch(setPlayStatus('ended'));
            setTimeout(() => {
               setPercent(0);
            }, 100);
            if (props.onMediaFinished) {
               props.onMediaFinished();
            }
         });
         audioRef?.current?.addEventListener('error', event => {});
         audioRef?.current?.addEventListener(
            'timeupdate',
            () => {
               if (audioRef !== null && audioRef.current?.currentTime) {
                  const currentTime = audioRef.current.currentTime;
                  const duration = audioRef.current.duration;
                  const percent = (currentTime / duration) * 100;
                  setPercent(Math.round(percent));
               }
            },
            false,
         );
         audioRef?.current?.addEventListener(
            'volumechange',
            function () {
               //audioRef.current.volume = setVolume;
            },
            false,
         );

         return () => {
            audioRef?.current?.remove('play');
            audioRef?.current?.remove('pause');
            audioRef?.current?.remove('ended');
            audioRef?.current?.remove('timeupdate');
         };
      }
   }, [audioRef, props.type, isMediaPlaying]);

   useEffect(() => {
      if (isMediaPlaying) {
         playCall(url);
      } else {
         pauseCall();
      }
   }, [url, isMediaPlaying]);

   useEffect(() => {
      if (PressClose) {
         props.onMediaFinished();
         pauseCall();
         return () => {
            pauseCall();
         };
      }
   }, [PressClose]);

   useEffect(() => {
      changedVolume();
      return () => changedVolume();
   }, [volume, props]);

   const changedVolume = () => {
      if (audioRef && audioRef.current?.volume) {
         const vd = parseFloat(volume);
         audioRef.current.volume = vd;
      }
   };
   const playCall = async url => {
      if (audioRef !== 'null' && audioRef.current) {
         audioRef.current.src = playerPath;
         audioRef.current.load();

         setTimeout(function () {
            const playPromise = audioRef.current.play();
            if (playPromise !== undefined) {
               playPromise
                  .then(_ => {
                     // Autoplay started!
                  })
                  .catch(error => {});
            }
         }, 0);
      }
   };
   const pauseCall = () => {
      if (audioRef && audioRef?.current?.play) {
         audioRef.current.pause();
         audioRef.current.currentTime = 0;
      }
   };

   const onPress = async () => {
      setPercent(0);
      if (props.type === 'audio') {
         props.onMediaClicked();
      } else {
         props.showAlsVideo(playerPath);
      }
   };

   return (
      <View>
         <TouchableOpacity
            onPress={() => onPress()}
            style={[style.container, props.style]}>
            {isMediaPlaying ? (
               <Progressbar
                  progress={percent}
                  status={isMediaPlaying}
                  progCircleTintColor={props?.progCircleTintColor}
               />
            ) : (
               <MediaIcon />
            )}
         </TouchableOpacity>
         {props.type === 'audio' ? (
            <audio
               ref={audioRef}
               src={playerPath}
               preload="auto"
               id="audio"
               controls={false}
            />
         ) : (
            <></>
         )}
      </View>
   );
};

const style = StyleSheet.create({
   container: {
      //width: 40,
      //height: 40,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
   },
   item: {
      alignItems: 'center',
      alignSelf: 'center',
      justifyContent: 'center',
      height: 20,
      width: 20,
      borderRadius: 16,
      //marginLeft: 8,
   },
   card: {
      width: '90%',
      height: 100,
      backgroundColor: '#FFF',
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingHorizontal: 16,
      paddingVertical: 10,
      borderRadius: 10,
      marginBottom: 10,
      elevation: 5,
      zIndex: 999,
   },
});
export default AudioPlayer;
